import { actionCreator,
  checkHttpStatus,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  manageTagActionTypes,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  GET_MASTER_TAGS_LIST_API,
  POST_MASTER_TAG_API,
  DELETE_MASTER_TAG_API,
  GET_MASTER_TAG_DETAILS_API,
} from '../constants/ApiConstants';
import {checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';

export const getMasterData = () => {
  let fetchUrl = `${GET_MASTERDATABYNAME}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(manageTagActionTypes.get_masterdata.REQUEST));
    fetch(fetchUrl, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'userRoleType' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(manageTagActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_masterdata search --', error);
      });
  };
};

export const getMasterTagsList = (searchObj) => {
  let queryParams = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(manageTagActionTypes.get_masterTagsList.REQUEST));
    fetch(`${GET_MASTER_TAGS_LIST_API}${queryParams}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(manageTagActionTypes.get_masterTagsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(manageTagActionTypes.get_masterTagsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_masterTagsList --', error);
      });
  };
};

export const saveMasterTag = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(manageTagActionTypes.post_masterTag.REQUEST));
    fetch(`${POST_MASTER_TAG_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(manageTagActionTypes.post_masterTag.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(manageTagActionTypes.post_masterTag.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_masterTag ', error);
      });
  };
};

export const getMasterTagDetails = (tagID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(manageTagActionTypes.get_masterTagDetails.REQUEST));
    fetch(`${GET_MASTER_TAG_DETAILS_API}?id=${tagID}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(manageTagActionTypes.get_masterTagDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(manageTagActionTypes.get_masterTagDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_masterTagDetails --', error);
      });
  };
};

export const deleteMasterTag = (tagID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(manageTagActionTypes.delete_masterTag.REQUEST));
    fetch(`${DELETE_MASTER_TAG_API}?id=${tagID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(manageTagActionTypes.delete_masterTag.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(manageTagActionTypes.delete_masterTag.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(manageTagActionTypes.delete_masterTag.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_masterTag ', error);
      });
  };
};

// export const getTagNameBySearchText = (keyword) => {
//   let queryParams = createSearchUrl(keyword);
//   // console.log(queryParams)
//   let fetchUrl = `${MANAGETAGAPI}${queryParams}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(manageTagActionTypes.get_tags.REQUEST));
//     fetch(fetchUrl, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         dispatch(actionCreator(manageTagActionTypes.get_tags.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error get_tags  --', error);
//       });
//   };
// };





// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/actions/ManageTagActions.js